import React from "react";
import ReactDOM from "react-dom";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import { withMapContext } from "./MapContext";
import { MuiThemeProvider } from "@material-ui/core/styles";
import themes from "../../../../themes/theme-context";

class Popup extends React.Component{
    constructor(props){
        super(props);
        this.popupRef = React.createRef();
        this.popup = null;
    }

    componentDidMount(){
        this.renderPopup(true);
    }

    renderPopup = (createPopup) =>{
        if(createPopup){
            if(this.popup){
                this.popup.remove();
            }

            const { map, position, marker, isCloseButton} = this.props;
            this.popup = new TrimbleMaps.Popup({
                                        closeButton: isCloseButton ? true : false,
                                        closeOnClick: false,
                                        anchor:"bottom",
                                        className:`popupContainer${marker ? " hasMarker" :""}`
                                      })
                                      .setDOMContent(this.popupRef.current)
                                      .addTo(map);
            let center = null;
            if(marker){
                marker.setPopup(this.popup);
                center = marker._lngLat;
            }else if(position){
                this.popup.setLngLat(position);
                center = position;
            }
      
        //    map.flyTo({center: center});
           
        }
        ReactDOM.render(
            <MuiThemeProvider theme={this.props.theme? themes[this.props.theme] : themes.modernLight}>
                {React.Children.only(this.props.children)}
            </MuiThemeProvider>,
            this.popupRef.current
            );
    }

    componentDidUpdate(prevProps){
        const { map, marker , position} = this.props;
        if(!map){
            return;
        }

        const positionChanged = marker !== prevProps.marker || position !== prevProps.position;
        if (map !== prevProps.map || positionChanged || this.props.forceRender || prevProps.children !== this.props.children) {
            this.renderPopup(positionChanged);
        }
    }

    componentWillUnmount(){
        if(this.props.marker){
            this.props.marker.setPopup(null);
        }
        this.popup.remove();
        ReactDOM.render(null, this.popupRef.current);
        this.popupRef =null;
    }

    render(){
        return (
            <div>
                <div ref={this.popupRef}></div>
            </div>
        );
    }

}


export default withMapContext(Popup)